import { RouteDefinition } from '../shared/navigation/route-definition';
import { RoutePaths } from '../shared/navigation/route-paths';
import { AlwaysShowRouteResolver } from '../shared/navigation/always-show-route-resolver';

export class SettingsRouteDefinition {
  public static getRoutes(
    showLoyalty: boolean,
    showFDM: boolean
  ): RouteDefinition {
    const menuItems: RouteDefinition = {
      path: RoutePaths.SETTINGS,
      resolver: AlwaysShowRouteResolver,
      title: 'Settings',
      icon: 'icon-settings.svg',
      position: 10,
      children: [
        {
          path: RoutePaths.NOTIFICATION,
          parentPath: RoutePaths.SETTINGS,
          title: 'Notification Settings',
          position: 13
        },
        {
          path: RoutePaths.COMPANY,
          parentPath: RoutePaths.SETTINGS,
          title: 'Company Settings',
          position: 1
        },
        {
          path: RoutePaths.REPORT,
          parentPath: RoutePaths.SETTINGS,
          title: 'Report Settings',
          position: 2
        },
        {
          path: RoutePaths.PRINT,
          parentPath: RoutePaths.SETTINGS,
          title: 'Print Settings',
          position: 3
        },
        {
          path: RoutePaths.APP,
          parentPath: RoutePaths.SETTINGS,
          title: 'App Settings',
          position: 4
        },
        {
          path: RoutePaths.MANAGER,
          parentPath: RoutePaths.SETTINGS,
          title: 'Manager Settings',
          position: 5
        },
        {
          path: RoutePaths.MENU,
          parentPath: RoutePaths.SETTINGS,
          title: 'Menu Settings',
          position: 6
        },
        {
          path: RoutePaths.CFD,
          parentPath: RoutePaths.SETTINGS,
          title: 'CFD App Settings',
          position: 7
        },
        {
          path: RoutePaths.EMAIL,
          parentPath: RoutePaths.SETTINGS,
          title: 'Email Settings',
          position: 8
        },
        {
          path: RoutePaths.INVOICE,
          parentPath: RoutePaths.SETTINGS,
          title: 'Invoice Settings',
          position: 9
        },
        {
          path: RoutePaths.STOCK,
          parentPath: RoutePaths.SETTINGS,
          title: 'Stock Settings',
          position: 11
        }
      ]
    };
    if (showLoyalty) {
      menuItems.children.push({
        path: RoutePaths.LOYALTY,
        parentPath: RoutePaths.SETTINGS,
        title: 'Loyalty Settings',
        position: 10
      });
    }
    if (showFDM) {
      menuItems.children.push({
        path: RoutePaths.FDM,
        parentPath: RoutePaths.SETTINGS,
        title: 'FDM Settings',
        position: 12
      });
    }
    return menuItems;
  }
}
